<div class="zen-main-container flex flex-col items-stretch justify-between">
  <div class="flex flex-row relative items-stretch w-full">
    <div class="flex flex-col relative bg-white gap-2 z-20 transition-all ease-expo !duration-1000 overflow-hidden"
      [ngClass]="{
        'w-20': collapse && !global.innerRoute,
        'w-80': !collapse && !global.innerRoute,
        'w-0 overflow-hidden': global.innerRoute
      }">
      <div
        class="fixed flex flex-col items-stretch w-[inherit] transition-all ease-expo !duration-1000 h-screen bg-white overflow-hidden top-20">
        <div class="flex flex-row items-center pt-1 leading-10 h-24 px-[1.875rem]">
          <div (click)="collapseColumn()"
            class="flex flex-col items-center justify-center w-5 btn text-zen leading-5 h-5 text-center rounded-full outline outline-zen outline-1 min-w-5">
            <i [ngClass]="{
                rotateY180: collapse,
                'rotate-0': !collapse,
                'fa-angle-left': !(language | language),
                'fa-angle-right': (language | language)
              }" class="fa-regular text-zen text-center ease-expo duration-500"></i>
          </div>
          <div class="transition-all overflow-hidden ease-expo duration-500" [ngClass]="collapse ? 'w-0' : 'w-[15rem]'">
            <h5 class="uppercase text-xs text-zen font-medium px-10 whitespace-nowrap">
              {{ "txtNavigation" | translate : language : ModuleNames.Shared }}
            </h5>
          </div>
        </div>

        <span></span>
        <div class="flex flex-col items-stretch relative">
          <div class="flex flex-col items-stretch absolute top-0 w-full">
            <ng-container *ngFor="let route of routes; let r = index">
              <span [ngClass]="link.isActive ? 'h-' + r * 20 : 'h-0'" [routerLink]="route.link" routerLinkActive
                #link="routerLinkActive"
                class="w-20 bg-transparent transform transition-all ease-expo duration-500"></span>
            </ng-container>
            <span class="w-full h-20 bg-zen/10"></span>
          </div>
          <div class="flex flex-col items-stretch w-full capitalize" [@listAnimation]="routes.length">
            <a *ngFor="let route of routes; let r = index"
              [matTooltip]="collapse ? (route.name | translate : language : ModuleNames.Shared) : ''"
              class="btn h-20 w-full leading-20 flex flex-row justify-start items-center text-zen"
              [routerLink]="route.link" routerLinkActive #link="routerLinkActive"
              [ngClass]="link.isActive ? 'text-exp' : 'text-zen/90'" [TourStep]="
                tourKey && (r == index || !index)
                  ? {
                      title: route.name | translate : language : ModuleNames.Shared,
                      text: route.name + '_' + tourKey | translate : language : ModuleNames.Shared,
                      order: 0,
                      tourKey: tourKey + '-' + route.title,
                      on: (language | language) ? 'left' : 'right'
                    }
                  : undefined
              ">
              <i *ngIf="!route.img" class="fa-regular text-2xl min-w-20 text-center" [ngClass]="'fa-' + route.icon"></i>
              <img *ngIf="route.img" class="min-w-20 text-center"
                [src]="link.isActive && route.imgActive ? route.imgActive : route.img" alt="" />
              <div class="transition-all overflow-hidden ease-expo duration-500"
                [ngClass]="collapse ? 'w-0' : 'w-[15rem]'">
                <h5 class="whitespace-nowrap">{{ route.name | translate : language : ModuleNames.Shared }}</h5>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
    @if(language){
    <div class="flex flex-col relative transition-all ease-expo duration-500" [ngClass]="{
        'w-20-right': collapse && !global.innerRoute,
        'w-80-right': !collapse && !global.innerRoute,
        'w-full': global.innerRoute
      }" [@routeInnerAnimations]="resolveRoute(o)">
      <router-outlet #o="outlet"></router-outlet>
    </div>
    }
  </div>
  <z-footer></z-footer>
</div>
